module.exports = __webpack_public_path__ + "static/media/chess.31ca9145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apps/chess.png
// module id = 569
// module chunks = 0